<template>
<div class="container-fluid" style="margin-bottom: 50px;">
	<service-toolbar :hide-archive-alert="isQuote ? false : true"></service-toolbar>
	
	<purchase-orders :is-service-po="true" :selected-po-slug="poSlug"></purchase-orders>
</div>
</template>
<script type="text/javascript">
import ServiceToolbar from "@/pages/project/services/ServiceToolbar"
import PurchaseOrders from "@/pages/project/PurchaseOrders"

import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "ServicePurchaseOrders",
	components: {
		PurchaseOrders,
		ServiceToolbar
	},
	mixins: [ServiceMixins],
	props: ["poSlug"],
	created() {
		this.fetchService()
	}

}
</script>